import IdleJs from 'idle-js';

export default class SessionExpire {
    constructor() {
        if(this.instance){
            return this.instance;
        }
        this.instance = this;
        this.pageTitle = document.title;
        this.sessionLifetime = $('meta[name=labcoat]').attr('data-timeout');
        if(this.sessionLifetime <= 7) {
            this.graceperiod = this.sessionLifetime * .1;
        } else {
            this.graceperiod = 5;
        }
        this.timeRemaining = 60 * this.graceperiod;
        var self = this;
        this.idle = new IdleJs({
            // sessionLifetime defined in laravel is in minutes, idle reads in ms.
            // subtract grace period and an additional 15 seconds.
            idle: ((self.sessionLifetime - self.graceperiod - .25) * 60 * 1000),
            // idle: 115 * 60 * 1000, // idle time in ms
            // events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
            events: [], // don't allow user interaction to reset the countdown
            // callbacks include [onIdle, onActive, onHide, onShow]
            onIdle: function () {
                self.keepTracking = false;
                self.idle.stop();
                self.sessionExpireCountdown();
            }, // callback function to be executed after idle time
            keepTracking: true, // set it to false if you want to be notified only on the first idleness change
            startAtIdle: false // set it to true if you want to start in the idle state
        });
      this.idle.start();
    }

    sessionExpireCountdown() {
        var minutes, seconds;

        // some vars will be appended to the document object so the blade can interact.
        this.showRemainLoggedInDialog();
        document.timeBeforeLogout = '';
        var self = this;
        document.logoutintervalid = setInterval(function () {
            minutes = parseInt(self.timeRemaining / 60, 10)
            seconds = parseInt(self.timeRemaining % 60, 10);

            // minutes = minutes < 10 ? "0" + minutes : minutes; // no need to zero-pad 5 minutes
            seconds = seconds < 10 ? "0" + seconds : seconds;
            document.timeBeforeLogout = "in " + minutes + ":" + seconds;
            document.title = minutes + ":" + seconds + " before your session expires | " + self.pageTitle;

            if (--self.timeRemaining < 0) {
                clearInterval(document.logoutintervalid);
                document.title = "Session Expired | " + self.pageTitle;
                    $('<input>')
                        .attr('type', 'hidden')
                        .attr('name', 'session_expired')
                        .val(true)
                        .appendTo($(".navbar .user-menu .logout-button"));
                    $(".navbar .user-menu .logout-button button").click();
            }
        }, 1000);
    }
    resetIdleTimer(){
        this.idle.reset();
    }
    showRemainLoggedInDialog() {
        var data = {modalId: 'extend_session'};
        var url = $('meta[name=labcoat]').attr('data-base-url') + '/extend-session';

        // Fetch the modal from the server
        $.ajax({
            type: "GET",
            url: url,
            data: data,
            error: function(data) {
                displayToast(data.responseJSON);
            },
            success: function(data) {
                // add the modal to the DOM and show it
                $('#main-content').append(data);
            }
        });
    }
}
